






































import { Component, Vue, Watch } from "vue-property-decorator"
import { IBreadcrumbItem } from "@/components/breadcrumb/extra"
import updateTdk, { formatTDK } from "@/utils/tdk"
@Component({
  name: "JXWD",
  components: {
    GameRecommend: () => import("@/components/GameRecommend/GameRecommend.vue"),
    Breadcrumb: () => import("@/components/breadcrumb/breadcrumb.vue"),
    LoadMore: () => import("@/components/loadMore/loadMore.vue"),
    NoMoreData: () => import("@/components/noMoreData/noMore.vue"),
    Empty: () => import("@/components/empty/empty.vue"),
    LoadMoreBtn: () => import("@/components/LoadMoreBtn/LoadMoreBtn.vue"),
    ChoiceItem: () => import("./components/ChoiceItem.vue")
  },
  tdk() {
    return this.$store.state.tdk
  }
})
export default class JXWD extends Vue {
  breads: IBreadcrumbItem[] = [
    { name: "首页", path: "/" },
    { name: "精选内容" }
  ]

  get seoChoice() {
    return this.$root.$tstore.modules.basic.getters.seoChoice
  }

  // ssr hook
  serverPrefetch() {
    return this.fetchData()
  }

  beforeMount() {
    if (this.seoChoice.data.length === 0) {
      this.fetchData()
    }
  }

  async fetchData() {
    return new Promise(async (resolve, reject) => {
      try {
        await this.$root.$tstore.modules.basic.actions.FETCH_SEO_CHOICE()
        await this.$root.$tstore.modules.tdk.actions.FETCH_TDK({
          type: "manual",
          _id_or_name: encodeURI("seo精选内容")
        })
        updateTdk.call(this)
        resolve("")
      } catch (error) {
        reject(error)
      }
    })
  }

  async getList() {
    const res = await this.$root.$tstore.getters.api.basic.seoChoice({
      page: this.seoChoice.page,
      page_size: this.seoChoice.page_size
    })
    // this.loading = false
    if (res.data.length === 0) {
      this.$root.$tstore.modules.basic.mutations.SET_SEO_CHOICE({
        finished: true
      })
    } else {
      this.$root.$tstore.modules.basic.mutations.SET_SEO_CHOICE({
        data: this.seoChoice.data.concat(res.data)
      })
    }
  }
  handleLoadMore() {
    this.$root.$tstore.modules.basic.mutations.SET_SEO_CHOICE({
      page: this.seoChoice.page + 1
    })
    this.getList()
  }
}
